<date-input (valueOut)="setElement($event, 2)" 
[initialPlaceHolder]="'Hasta'" [value]="elementSelected"></date-input>